import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, useParams } from 'react-router-dom';

import Header from '../Header.js';
import ReportFeedbackBox from '../boxes/ReportFeedbackBox.js';
import ReportViewBox from '../boxes/ReportViewBox.js';
import MedicReportFeedbackBox from '../boxes/MedicReportFeedbackBox.js';
import ProtocolAssessmentBox from '../boxes/ProtocolAssessmentBox.js';
import ReportTestsBox from '../boxes/ReportTestsBox.js';
import BoxTabs from '../boxes/BoxTabs.js';
import Footer from '../Footer.js';
import './ReportPage.css';

// import '../../../fonts/fonts.css';

const ReportPage = ({user, reportVisible = true}) => {
    let { reportId } = useParams();
    
    const [isSmallScreen, setIsSmallScreen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 1600); // screen width cutoff
        };
    
        handleResize(); // Initial check
        window.addEventListener('resize', handleResize);
    
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Define tabs configuration
    const tabs = [
        {
            label: "Report Overview",
            component: ReportFeedbackBox,
            props: { user: user, reportId: reportId }
        },
        {
            label: "Medic View",
            component: MedicReportFeedbackBox,
            props: { user: user, reportId: reportId }
        },
        {
            label: "Detailed PCR",
            component: ReportViewBox,
            props: { user: user, reportId: reportId }
        },
        {
            label: "All Tests",
            component: ReportTestsBox,
            props: { user: user, reportId: reportId }
        },
        // Only show Protocol Assessment tab for ADMIN_SUB users
        // ...(user.subscriptions.includes('ADMIN_SUB') ? [
        {
            label: "Protocol Assessment",
            component: ProtocolAssessmentBox,
            props: { user: user, reportId: reportId }
        }
        // ] : [])
    ];

    return (
        <div>
            <Header 
                user={user}
                buttonsVisible={{
                    homeButton: true,
                    qiButton: false,
                    medicViewButton: false
                }}
                reportId={reportId}
                pageTitle="Response"
            />
            
            {reportVisible ? (
                <div className="single-screen-container">
                    <div className='box-spacer'/>
                    <BoxTabs 
                        tabs={tabs}
                        defaultTabIndex={0}
                        isSmallScreen={isSmallScreen}
                    />
                </div>
            ) : (
                <div className="single-screen-container">
                    <BoxTabs 
                        tabs={tabs}
                        defaultTabIndex={0}
                        isSmallScreen={isSmallScreen}
                    />
                </div>
            )}
            <Footer sticky={reportVisible} />
        </div>
    );
};

export default ReportPage;